// utils/cache.ts

// 定义缓存工具的方法接口
interface CacheUtil {
  set: (key: string, value: string) => void;
  get: (key: string) => string | null;
  setJSON: <T>(key: string, jsonValue: T) => void;
  getJSON: <T>(key: string) => T | null;
  remove: (key: string) => void;
}

/**
 * 创建缓存对象工厂函数，避免代码重复
 * @param storage 存储对象 (sessionStorage 或 localStorage)
 */
const createCache = (storage: Storage): CacheUtil => {
  return {
    set(key: string, value: string): void {
      if (key != null && value != null) {
        storage.setItem(key, value);
      }
    },
    get(key: string): string | null {
      if (key == null) {
        return null;
      }
      return storage.getItem(key);
    },
    setJSON<T>(key: string, jsonValue: T): void {
      if (jsonValue != null) {
        this.set(key, JSON.stringify(jsonValue));
      }
    },
    getJSON<T>(key: string): T | null {
      const value = this.get(key);
      if (value != null) {
        try {
          return JSON.parse(value) as T;
        } catch (e) {
          console.error(`Failed to parse JSON for key: ${key}`, e);
          return null;
        }
      }
      return null;
    },
    remove(key: string): void {
      storage.removeItem(key);
    },
  };
};

// 导出默认对象
export default {
  /**
   * 会话级缓存
   */
  session: createCache(sessionStorage),
  /**
   * 本地缓存
   */
  local: createCache(localStorage),
};
